import React from 'react';

export function UserLabel(props: { user: { firstName: string | null; lastName: string | null } }) {
    if (!props.user || (!props.user.firstName && !props.user.lastName)) {
        return null;
    }
    return (
        <>
            {props.user.firstName} {props.user.lastName}
        </>
    );
}
